export { vendors_PT_BR } from "./vendor-pt-br";
export type { vendorTranslations } from "./vendor-pt-br";
export { vendors_EN_US } from "./vendor-en-us";
export { vendors_ES_MX } from "./vendor-es-mx";
export { vendors_FR_FR } from "./vendor-fr-fr";
